export default __webpack_public_path__ + "static/media/avatar.17a6df31.svg";